import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Row, Col } from 'antd'

import IconWithTextCard from 'components/Dashboard/IconWithTextCard'

import { requestMessagesCounter, requestUsersCounter } from 'redux/Dashboard/actions'

// import GraphStats from 'components/Dashboard/GraphStats'
import GraphStats from 'components/Dashboard/Graph/GraphStatsV2'
import MessagesToday from 'components/Dashboard/MessagesToday'
import MessagesThisMonth from 'components/Dashboard/MessagesThisMonth'

import UsersToday from 'components/Dashboard/UsersToday'
import UsersThisMonth from 'components/Dashboard/UsersThisMonth'

import ConcurrentConnections from 'components/Dashboard/ConcurrentConnections'

class Dashboard extends React.Component {
    componentDidMount() {
        const { requestMessagesCounter, requestUsersCounter } = this.props

        requestMessagesCounter()
        requestUsersCounter()
    }

    componentWillReceiveProps(nextProps) {
        const { requestMessagesCounter, requestUsersCounter } = nextProps

        requestMessagesCounter()
        requestUsersCounter()
    }

    render() {
        const { currentAppId } = this.props

        console.log(currentAppId)

        return (
            <Row>
                <Col xl={8} lg={8} md={8} sm={12} xs={24}>
                    <UsersToday />
                </Col>
                <Col xl={8} lg={8} md={8} sm={12} xs={24}>
                    <MessagesToday />
                </Col>
                <Col xl={8} lg={8} md={8} sm={12} xs={24}>
                    <IconWithTextCard title="Plan" subTitle={currentAppId === '209c3a06-18e2-4a22-bfaa-ce850dd8694a' ? 'CUSTOM' : 'FREE'} icon="euro" cardColor="orange" />
                </Col>

                <Col xl={8} lg={8} md={8} sm={12} xs={24}>
                    <UsersThisMonth />
                </Col>
                <Col xl={8} lg={8} md={8} sm={12} xs={24}>
                    <MessagesThisMonth />
                </Col>
                <Col xl={8} lg={8} md={8} sm={12} xs={24}>
                    <ConcurrentConnections />
                </Col>

                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                    <GraphStats />
                </Col>
            </Row>
        )
    }
}

const mapStateToProps = state => ({
    currentAppId: state.ekko.currentAppId
})

const mapActionsToProps = dispatch => ({
    requestMessagesCounter: bindActionCreators(requestMessagesCounter, dispatch),
    requestUsersCounter: bindActionCreators(requestUsersCounter, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(Dashboard)
